import { GroupManagementBlockUser } from "./GroupManagementBlockUser";

export default function GroupManagementUsers({ groupId, users }) {

  return (
    <div className="flex flex-col">
      <h2 className="font-bold text-md mt-2 mb-4">Ativar/Desativar usuários neste Bolão</h2>

      <div className="mb-8">
        <div className="flex flex-col space-y-2">
          {users.map((user) => (
            <GroupManagementBlockUser key={user.id} groupId={groupId} user={user}/>
          ))}
        </div>
      </div>
    </div>
  );
}